module.exports = new __parcel__URL__("step_two_vector_dark_optimal.f8537d1f.png").toString();